import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { PaymentUtilService } from './../../../common/payment/services/payment-util/payment-util.service';

@Component({
  selector: 'app-utm-popup',
  templateUrl: './utm-popup.component.html',
  styleUrls: ['./utm-popup.component.scss']
})
export class UtmPopupComponent implements OnInit {

  constructor(
    public paymentUtilService: PaymentUtilService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
  }

  activateHundredRs() {
    this.paymentUtilService.utmProceedClicked = true;
    this.dialog.closeAll();
    setTimeout(() => {
      window.scrollTo({ top: 1000, behavior: 'smooth' });
    }, 500);
  }

}
